/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Show_CounterInputs */

const en_live_caption_show_counter = /** @type {(inputs: Live_Caption_Show_CounterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show character counter`)
};

const fr_live_caption_show_counter = /** @type {(inputs: Live_Caption_Show_CounterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher le compteur de caractères`)
};

const de_live_caption_show_counter = /** @type {(inputs: Live_Caption_Show_CounterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichenzähler anzeigen`)
};

const it_live_caption_show_counter = /** @type {(inputs: Live_Caption_Show_CounterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra il contatore dei caratteri`)
};

const ru_live_caption_show_counter = /** @type {(inputs: Live_Caption_Show_CounterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать счетчик символов`)
};

const es_live_caption_show_counter = /** @type {(inputs: Live_Caption_Show_CounterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar contador de caracteres`)
};

const zh_cn2_live_caption_show_counter = /** @type {(inputs: Live_Caption_Show_CounterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示字符计数器`)
};

const ja_live_caption_show_counter = /** @type {(inputs: Live_Caption_Show_CounterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字数カウンターを表示`)
};

const hi_live_caption_show_counter = /** @type {(inputs: Live_Caption_Show_CounterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैरेक्टर काउंटर दिखाएँ`)
};

const pt_pt2_live_caption_show_counter = /** @type {(inputs: Live_Caption_Show_CounterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar contador de caracteres`)
};

/**
* | output |
* | --- |
* | "Show character counter" |
*
* @param {Live_Caption_Show_CounterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_show_counter = /** @type {((inputs?: Live_Caption_Show_CounterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Show_CounterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_show_counter(inputs)
	if (locale === "de") return de_live_caption_show_counter(inputs)
	if (locale === "it") return it_live_caption_show_counter(inputs)
	if (locale === "ru") return ru_live_caption_show_counter(inputs)
	if (locale === "es") return es_live_caption_show_counter(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_show_counter(inputs)
	if (locale === "ja") return ja_live_caption_show_counter(inputs)
	if (locale === "hi") return hi_live_caption_show_counter(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_show_counter(inputs)
	return en_live_caption_show_counter(inputs)
});